import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectShowHotels = createSelector(selectJsonQuery, jsonQuery => getTermValue('show_hotels')(jsonQuery));
